























import { Component, Vue } from "vue-property-decorator";
import { UserModule } from "@/store/modules/user.store";

@Component({
  components: {}
})
export default class LoginPermissionInsufficient extends Vue {
  constructor() {
    super();
  }

  async backToLogin() {
    await UserModule.logout();
    this.$router.push({ path: "/login" });
  }
}
